// Status of a GDPR "Right to Erasure" request lifecycle
export enum RightToErasureRequestStatus {
  Processing = 'processing',
  Completed = 'completed',
  Failed = 'failed',
}
